
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"9.6","cy":"9.6","r":"9.6","fill":"#fff"}}),_c('path',{attrs:{"d":"M9.6 3.44a6.16 6.16 0 110 12.32 6.16 6.16 0 010-12.32z","stroke":"#C91919","stroke-width":"1.68"}}),_c('path',{attrs:{"d":"M8.917 13.007h1.542c-.3-.394-.45-.816-.45-1.264 0-.259.036-.443.108-.553.196-.3.383.06.461.239.15.344.332.742.713.866.816.267 1.393-.53 1.393-1.265 0-.596-.32-1.074-.66-1.535-.382-.516-.792-1.01-1.184-1.52A21.738 21.738 0 019.68 6.29c-.483.752-.868 1.314-1.156 1.687L7.181 9.742c-.27.353-.472.799-.472 1.248 0 .627.349 1.362 1.07 1.362.554 0 .848-.47 1.035-.929.068-.166.274-.521.45-.239.076.122.114.306.114.553 0 .476-.161.904-.461 1.27z","fill":"#001370"}}),_c('path',{attrs:{"d":"M9.6.72a8.88 8.88 0 110 17.76A8.88 8.88 0 019.6.72z","stroke":"#001370","stroke-width":"1.44"}})])
          )
        }
      }
    